// extracted by mini-css-extract-plugin
export default {"wrapper":"UiDateRangePicker_wrapper","icon":"UiDateRangePicker_icon"};